import React from 'react';
import { makeStyles } from 'tss-react/mui';

import ButtonBase from '@mui/material/ButtonBase';
import type { TypographyProps } from '@mui/material/Typography';
import Typography from '@mui/material/Typography';
import classNames from 'classnames';

const useStyles = makeStyles()(() => ({
  root: {
    textTransform: 'capitalize',
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
}));

type QTextButtonProps = {
  tabIndex?: number;
  onClick?: () => void;
  title: string;
} & TypographyProps;

const QTextButton = ({
  tabIndex = -1,
  className,
  onClick,
  title,
  variant = 'captionRegular',
  ...other
}: QTextButtonProps) => {
  const { classes } = useStyles();

  return (
    <ButtonBase sharedcomponentid='Q_TEXT_BUTTON' tabIndex={tabIndex} onClick={onClick}>
      <Typography className={classNames(classes.root, className)} variant={variant} {...other}>
        {title.toLowerCase()}
      </Typography>
    </ButtonBase>
  );
};

export default QTextButton;
